var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicrophone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 60,
    viewBox: "0 0 32 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 43C21.2531 43 25.5 38.9784 25.5 34.0043V15.9958C25.5 11.0215 21.253 7 16 7C10.747 7 6.5 11.0216 6.5 15.9958V34.0043C6.5 38.9785 10.747 43 16 43Z",
    fill: "currentColor",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7408 59.0394V47.8742L14.2854 47.8334C6.56732 47.1422 1.02832 40.7734 1.02832 33.0296C1.02832 32.4711 1.46032 32.0391 2.01885 32.0391C2.57739 32.0391 3.00939 32.4711 3.00939 33.0296C3.00939 40.0879 8.4054 45.91 15.7313 45.91C23.027 45.91 28.9903 40.1567 28.9903 33.0683C28.9903 32.5098 29.4223 32.0778 29.9808 32.0778C30.5393 32.0778 30.9713 32.5098 30.9713 33.0683C30.9713 40.7236 24.9235 47.082 17.1145 47.8341L16.6624 47.8777L16.6621 59.0394C16.662 59.5699 16.232 60 15.7014 60C15.1709 60 14.7408 59.5699 14.7408 59.0394Z",
    fill: "currentColor",
    fillOpacity: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophone);
export default __webpack_public_path__ + "static/media/microphone.f01fae8669b7619a9c1978829886999e.svg";
export { ForwardRef as ReactComponent };